import { gql } from '@apollo/client';

import { CHALLENGE_TAG_BASIC } from './open-challenge';
import { FILE } from './upload';
import { USER_BASICS } from './user';

export const COMMUNITY_ANNOUNCEMENT = gql`
  fragment communityAnnouncement on CommunityAnnouncement {
    id
    community {
      ...challengeTagBasic
    }
    type
    createdAt
  }
`;

export const ANNOUNCEMENT = gql`
  fragment announcement on Announcement {
    id
    subject
    announcement
    createdAt
    authorUser {
      id
      role
      fullName
      image {
        url
      }
    }
    communities {
      ...communityAnnouncement
    }
    users {
      id
      user {
        ...userBasics
      }
      createdAt
    }
  }
`;

export const CREATE_ANNOUNCEMENT = gql`
  mutation sendAnnouncements($input: SendAnnouncementDto) {
    sendAnnouncements(input: $input) {
      ...announcement
    }
  }
  ${ANNOUNCEMENT}
  ${COMMUNITY_ANNOUNCEMENT}
  ${CHALLENGE_TAG_BASIC}
  ${FILE}
  ${USER_BASICS}
`;

export const LIST_ANNOUNCEMENT = gql`
  query ListAnnouncements($page: Int, $limit: Int) {
    listAnnouncements(page: $page, limit: $limit) {
      announcements {
        ...announcement
      }
      total
    }
  }
  ${ANNOUNCEMENT}
  ${COMMUNITY_ANNOUNCEMENT}
  ${CHALLENGE_TAG_BASIC}
  ${FILE}
  ${USER_BASICS}
`;
